// Israel-local (Asia/Jerusalem) parts of a UTC instant. Recurring slots are
// keyed in Israel time on the server, so the client must match in Israel time
// too — regardless of the editor's browser timezone.
const WEEKDAY_BY_INDEX = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
const WEEKDAY_SHORT = { Sun: "sun", Mon: "mon", Tue: "tue", Wed: "wed", Thu: "thu", Fri: "fri", Sat: "sat" };

export const WEEKDAY_CODES = WEEKDAY_BY_INDEX;

export function israelParts(utcMs) {
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat("en-US", {
      timeZone: "Asia/Jerusalem",
      hourCycle: "h23",
      weekday: "short",
      hour: "2-digit",
      minute: "2-digit",
    })
      .formatToParts(new Date(utcMs))
      .map((p) => [p.type, p.value]),
  );
  return { weekday: WEEKDAY_SHORT[parts.weekday], hhmm: `${parts.hour}:${parts.minute}` };
}
